interface Version {
  id: string;
  createdAt: Date;
}

/** Creation moment of the shown questionnaire version */
export const getVersionDate = (versions: Version[], versionId: string) =>
  versions.find((version) => version.id === versionId)?.createdAt;
